import React from "react";

import "../../../assets/css/scss/section/player/_infoContentVert.scss";
import { BASEBALL_STATISTICS } from "../../../constant/match";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../../interfaces/redux";

const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return "--";

  const date = new Date(dateString);

  // Check if date is valid
  if (isNaN(date.getTime())) return "--";

  return date.toISOString().slice(0, 10).replaceAll("-", "/");
};

export default function InfoContentVert(props: any) {
  const data = props?.data;
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";
  return (
    <div className="info-content-vert">
      <div className="profile-title theme-dark-gray">
        <h3 className="bold h4 theme-green mb-0 text-capitalize">
          {BASEBALL_STATISTICS["player_profile"][selectedLang]["player_info"]}
        </h3>
      </div>
      <div className="profile-detail theme-gray">
        <div className="d-flex mb-3 align-items-center">
          <div>
            <h4 className="font-semibold text-uppercase h6 pr-2 text-uppercase">
              {BASEBALL_STATISTICS["player_profile"][selectedLang]["name"]} :
            </h4>
          </div>
          <div>
            <h5 className="font-light h6 text-uppercase">
              {data?.player_name}
            </h5>
          </div>
        </div>
        <div className="d-flex mb-3 align-items-center">
          <div>
            <h4 className="font-semibold text-uppercase h6 pr-2 text-uppercase">
              {BASEBALL_STATISTICS["player_profile"][selectedLang]["ht_wt"]} :
            </h4>
          </div>
          <div>
            <h5 className="font-light h6">
              {data?.player_height + "/" + data?.player_weight}
            </h5>
          </div>
        </div>
        <div className="d-flex mb-3 align-items-center">
          <div>
            <h4 className="font-semibold text-uppercase h6 pr-2 text-uppercase">
              {BASEBALL_STATISTICS["player_profile"][selectedLang]["dob"]} :
            </h4>
          </div>
          <div>
            <h5 className="font-light h6">{formatDate(data?.date_of_birth)}</h5>
          </div>
        </div>
        <div className="d-flex mb-3 align-items-center">
          <div>
            <h4 className="font-semibold text-uppercase h6 pr-2 text-uppercase">
              {BASEBALL_STATISTICS["player_profile"][selectedLang]["bat_thr"]} :
            </h4>
          </div>
          <div>
            <h5 className="font-light h6 text-uppercase">
              {data?.bat + "/" + data?.thr}
            </h5>
          </div>
        </div>
        <div className="d-flex mb-3 align-items-center">
          <div>
            <h4 className="font-semibold text-uppercase h6 pr-2">
              {
                BASEBALL_STATISTICS["player_profile"][selectedLang][
                  "birthplace"
                ]
              }{" "}
              :
            </h4>
          </div>
          <div>
            <h5 className="font-light h6 text-capitalize line-clamp-2">
              {data?.birth_place || "--"}
            </h5>
          </div>
        </div>
        <div className="d-flex mb-3 align-items-center">
          <div>
            <h4 className="font-semibold text-uppercase h6 pr-2 text-uppercase">
              {BASEBALL_STATISTICS["player_profile"][selectedLang]["status"]} :
            </h4>
          </div>
          <div>
            <h5 className="active-status font-light h6">
              {data?.active_status ? (
                <>
                  <span className="dot active"></span>{" "}
                  {
                    BASEBALL_STATISTICS["player_profile"][selectedLang][
                      "status_active"
                    ]
                  }
                </>
              ) : (
                <>
                  <span className="dot"></span>{" "}
                  {
                    BASEBALL_STATISTICS["player_profile"][selectedLang][
                      "status_inactive"
                    ]
                  }
                </>
              )}
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}
